export const mockOrganisationDefaultLocale = {
  defaultLocale: 'en-GB',
  organisationId: 'staging_organisation_000000CTmMjZD5OKgltYxrpra'
}

export const mockOrganisationDefaultLocaleNull = {
  defaultLocale: null,
  organisationId: 'staging_organisation_000000CTmMjZD5OKgltYxrpra'
}
